import { presenceStore } from "../lib/presence";
import { fieldLabel } from "../lib/fields";
export function PresenceAvatars({ loanId, userId }: { loanId: string; userId: string }) {
  const presence = presenceStore.use();
  const people = (presence.get(loanId) ?? []).filter((p) => p.user_id !== userId);
  return <div className="flex items-center gap-2" aria-label="Others on this loan">{people.map((p) => {
    const label = `${p.name} · ${p.field ? `editing ${fieldLabel(p.field)}` : "viewing"}`;
    return <span key={p.user_id} title={label} aria-label={label} className="flex items-center gap-1 text-xs text-ink-2"><span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-primary font-semibold text-on-primary">{p.name.split(/\s+/).map((n) => n[0]).slice(0, 2).join("")}</span>{p.field ? fieldLabel(p.field) : "Viewing"}</span>;
  })}</div>;
}
